module.exports = __webpack_public_path__ + "static/media/logo.25524715.png";